import { render, staticRenderFns } from "./PurposeFund.vue?vue&type=template&id=1090a518&scoped=true&"
import script from "./PurposeFund.vue?vue&type=script&lang=js&"
export * from "./PurposeFund.vue?vue&type=script&lang=js&"
import style0 from "./PurposeFund.vue?vue&type=style&index=0&id=1090a518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1090a518",
  null
  
)

export default component.exports